import React from 'react';

import Grid from '@mui/material/Grid';
import { useTheme } from '@mui/material/styles';

export const NoProcedureFlow = ({ procedureName }) => {
  const theme = useTheme();

  return (
    <Grid className="flex-center height-100" container>
      <Grid
        item
        xs={10}
        sx={{
          color: theme.palette.primary.danger,
          textAlign: 'center',
          alignSelf: 'center',
        }}
      >
        Please, select procedure flow for the <strong>{procedureName}</strong> in the Admin panel
      </Grid>
    </Grid>
  );
};
